import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import debounce from 'lodash/fp/debounce';
import t from '@instructure/quiz-i18n/es/format-message';
import { TagWrapper } from '@instructure/quiz-core';
import { Spinner } from '@instructure/ui-spinner';
import { Text } from '@instructure/ui-text';
import { Flex, Select, SELECT_EMPTY_OPTION } from '@instructure/quiz-common';
export var FilterAsyncSearch = /*#__PURE__*/function (_Component) {
  function FilterAsyncSearch() {
    var _this;
    _classCallCheck(this, FilterAsyncSearch);
    _this = _callSuper(this, FilterAsyncSearch, arguments);
    _defineProperty(_this, "setInputRef", function (inputRef) {
      _this.inputRef = inputRef;
    });
    _defineProperty(_this, "state", {
      highlightedFilterKey: null,
      inputValue: '',
      isLoading: false,
      isShowingOptions: false,
      namedIpFilters: []
    });
    _defineProperty(_this, "handleShowOptions", function () {
      _this.setState({
        isLoading: true,
        isShowingOptions: true
      });
      _this.search('');
    });
    _defineProperty(_this, "handleHideOptions", function () {
      var allFilters = _this.filterNamedFilters(_this.state.namedIpFilters);
      // a filter matching user input exists
      if (allFilters.length === 1) {
        var onlyFilter = allFilters[0];
        // automatically select the matching filter
        var label = onlyFilter.name;
        if (label && label.toLowerCase() === _this.state.inputValue.toLowerCase()) {
          _this.changeSelectedFilters(_this.props.selectedFilters.concat({
            name: onlyFilter.name,
            ips: onlyFilter.filter
          }));
        }
      }
      _this.setState({
        inputValue: '',
        isShowingOptions: false,
        highlightedFilterKey: null
      });
    });
    _defineProperty(_this, "handleBlur", function () {
      _this.setState({
        highlightedFilterKey: null
      });
    });
    _defineProperty(_this, "changeSelectedFilters", function (filters) {
      _this.props.onSelectionChange(filters);
    });
    _defineProperty(_this, "handleHighlightOption", function (event, _ref) {
      var id = _ref.id;
      event.persist();
      var filter = _this.getFilterByKey(id);
      if (!filter) return;
      _this.setState(function (state) {
        return {
          highlightedFilterKey: id,
          inputValue: event.type === 'keydown' ? filter.name : state.inputValue
        };
      });
    });
    _defineProperty(_this, "handleSelectOption", function (event, _ref2) {
      var id = _ref2.id;
      var filter = _this.getFilterByKey(id);
      if (!filter) return;
      _this.changeSelectedFilters(_this.props.selectedFilters.concat({
        name: filter.name,
        ips: filter.filter
      }));
      _this.setState({
        inputValue: '',
        isShowingOptions: false
      });
    });
    _defineProperty(_this, "handleInputChange", function (event) {
      var value = event.target.value;
      var common = {
        inputValue: value,
        isShowingOptions: true,
        namedIpFilters: []
      };
      _this.setState(_objectSpread(_objectSpread({}, common), {}, {
        isLoading: true,
        highlightedFilterKey: null
      }));
      _this.search(value);
    });
    _defineProperty(_this, "handleKeyDown", function (event) {
      var inputValue = _this.state.inputValue;
      if (event.keyCode === 8) {
        // when backspace key is pressed
        if (inputValue === '' && _this.props.selectedFilters.size > 0) {
          // remove last selected filter, if input has no entered text
          _this.changeSelectedFilters(_this.props.selectedFilters.slice(0, -1));
          _this.setState({
            highlightedFilterKey: null
          });
        }
      }
    });
    _defineProperty(_this, "dismissTag", function (key) {
      var updatedFilters = _this.props.selectedFilters.filter(function (filter) {
        return key !== _this.getSelectedFilterKey(filter);
      });
      _this.changeSelectedFilters(updatedFilters);
      _this.setState({
        highlightedFilterKey: null
      }, function () {
        _this.inputRef.focus();
      });
    });
    _this.search = debounce(_this.props.debounceDelay, function (value) {
      return _this.props.getNamedIpFilters(value).then(function (response) {
        var namedIpFilters = response.json.quiz_ip_filters;
        var filteredNamedFilters = _this.filterNamedFilters(namedIpFilters);
        _this.setState({
          namedIpFilters: namedIpFilters,
          highlightedFilterKey: filteredNamedFilters.length ? _this.getFilterKey(filteredNamedFilters[0]) : _this.state.highlightedFilterKey,
          isLoading: false
        });
      });
    });
    return _this;
  }
  _inherits(FilterAsyncSearch, _Component);
  return _createClass(FilterAsyncSearch, [{
    key: "getFilterKey",
    value: function getFilterKey(filter) {
      return "".concat(filter.name, "-").concat(filter.filter[0], "-").concat(filter.filter[1]);
    }
  }, {
    key: "getSelectedFilterKey",
    value: function getSelectedFilterKey(filter) {
      var jsFilter = Map.isMap(filter) ? filter.toJS() : filter;
      var name = jsFilter.name,
        ips = jsFilter.ips;
      var range = List.isList(ips) ? ips.toJS() : ips;
      return "".concat(name, "-").concat(range[0], "-").concat(range[1]);
    }
  }, {
    key: "getFilterByKey",
    value: function getFilterByKey(key) {
      var _this2 = this;
      return this.state.namedIpFilters.find(function (filter) {
        return _this2.getFilterKey(filter) === key;
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(filter) {
      var _this3 = this;
      return this.props.selectedFilters.some(function (selectedFilter) {
        return _this3.getSelectedFilterKey(selectedFilter) === _this3.getFilterKey(filter);
      });
    }
  }, {
    key: "isHighlighted",
    value: function isHighlighted(filter) {
      return this.state.highlightedFilterKey && this.state.highlightedFilterKey === this.getFilterKey(filter);
    }
  }, {
    key: "filterNamedFilters",
    value: function filterNamedFilters(filters) {
      var _this4 = this;
      var uniqueKeys = new Set();
      return this.props.selectionFilter(filters).filter(function (filter) {
        var key = _this4.getFilterKey(filter);
        if (!_this4.isSelected(filter) && !uniqueKeys.has(key)) {
          uniqueKeys.add(key);
          return true;
        }
        return false;
      });
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this5 = this;
      return this.props.selectedFilters.map(function (filter, index) {
        var jsFilter = Map.isMap(filter) ? filter.toJS() : filter;
        var name = jsFilter.name,
          ips = jsFilter.ips;
        var range = List.isList(ips) ? ips.toJS() : ips;
        var tagText = "".concat(name, " (").concat(range[0], " to ").concat(range[1], ")");
        return /*#__PURE__*/React.createElement(TagWrapper, {
          text: tagText,
          key: _this5.getSelectedFilterKey(filter),
          id: _this5.getSelectedFilterKey(filter),
          index: index,
          onClick: _this5.dismissTag,
          themeOverride: {
            maxWidth: 'auto'
          }
        });
      });
    }
  }, {
    key: "renderFilterText",
    value: function renderFilterText(filter) {
      return "".concat(filter.filter[0], " to ").concat(filter.filter[1], "   |   ").concat(filter.account);
    }
  }, {
    key: "renderFilters",
    value: function renderFilters(filters) {
      var _this6 = this;
      return filters.map(function (filter) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          id: _this6.getFilterKey(filter),
          key: _this6.getFilterKey(filter),
          isHighlighted: _this6.isHighlighted(filter)
        }, /*#__PURE__*/React.createElement(Flex, {
          direction: "column"
        }, /*#__PURE__*/React.createElement(Text, null, filter.name), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
          margin: "0 0 0 x-small",
          color: _this6.isHighlighted(filter) ? 'secondary-inverse' : 'secondary'
        }, _this6.renderFilterText(filter)))));
      });
    }
  }, {
    key: "emptyFilter",
    value: function emptyFilter() {
      return t('No Results');
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var filters = this.filterNamedFilters(this.state.namedIpFilters);
      return filters.length ? this.renderFilters(filters) : /*#__PURE__*/React.createElement(Select.Option, {
        id: SELECT_EMPTY_OPTION,
        key: SELECT_EMPTY_OPTION
      }, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading'),
        size: "x-small"
      }) : this.emptyFilter());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        isShowingOptions = _this$state.isShowingOptions;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
        renderLabel: this.props.searchLabel,
        inputValue: inputValue,
        isShowingOptions: isShowingOptions,
        inputRef: this.setInputRef,
        onBlur: this.handleBlur,
        onInputChange: this.handleInputChange,
        onRequestShowOptions: this.handleShowOptions,
        onRequestHideOptions: this.handleHideOptions,
        onRequestHighlightOption: this.handleHighlightOption,
        onRequestSelectOption: this.handleSelectOption,
        onKeyDown: this.handleKeyDown,
        renderBeforeInput: this.props.selectedFilters.size > 0 ? this.renderTags() : null,
        isInline: true
      }, this.renderOptions()));
    }
  }]);
}(Component);
_defineProperty(FilterAsyncSearch, "propTypes", {
  debounceDelay: PropTypes.number,
  onSelectionChange: PropTypes.func.isRequired,
  getNamedIpFilters: PropTypes.func,
  selectedFilters: ImmutablePropTypes.list.isRequired,
  selectionFilter: PropTypes.func,
  searchLabel: PropTypes.string.isRequired
});
_defineProperty(FilterAsyncSearch, "defaultProps", {
  debounceDelay: 500,
  selectionFilter: function selectionFilter(value) {
    return value;
  },
  getNamedIpFilters: null
});